import { BUTTON_HEIGHT, FONT_SIZE } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
import styled from "styled-components";

export const Styles = styled.div<{
  hideScrollbar?: boolean;
  hideScroll?: boolean;
  showDisplaySizeSelector?: boolean;
  text_scale?: "small" | "medium" | "large";
  containerHeight?: number | string;
}>`
  position: relative;
  .quickview-header_vertical {
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    transform: translateX(-100%);
    gap: 5px;
  }
  .container-quickview {
    height: ${({ containerHeight }) =>
      containerHeight ? containerHeight : "calc(-95px + 56.5vh)"};
    width: 100%;
    background-color: #fff;
    padding: 0px 24px 24px 24px;
    overflow: ${({ hideScroll }) => (hideScroll ? "hidden" : "auto")};
    margin: 12px 0px;

    ${({ hideScroll }) =>
      hideScroll &&
      `
    display: flex;
    flex-direction: column;
  `}

    ${({ hideScrollbar }) =>
      hideScrollbar &&
      `
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  `}

  .quickview-header {
      display: flex;
      column-gap: 8px;
      position: sticky;
      top: 0;
      z-index: 105;
      background: #fff;
      padding: 12px;
      .button-view-detail {
        position: relative;
        background: #1e3665;
        color: white;
        border: none;
        cursor: pointer;
        border-radius: 3px !important;

        height: ${({ text_scale }) =>
          `${
            Number(BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]) + 3
          }px`}!important;
        font-size: ${({ text_scale }) =>
          FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]} !important;
        max-width: ${({ text_scale }) =>
          `${
            text_scale?.includes(DISPLAY_SIZES.SMALL)
              ? 90
              : text_scale?.includes(DISPLAY_SIZES.MEDIUM)
              ? 120
              : 140
          }px !important`};
        width: fit-content;
        min-width: fit-content;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 5px;
        gap: 8px;

        &:hover {
          color: #40a9ff;
        }

        &.notEditable,
        &:disabled {
          background: #d9dde5;
          color: #a3a6b3;
          cursor: not-allowed;
        }
      }
      .btn-close {
        background: #1e3665 !important;
        height: ${({ text_scale }) =>
          `${
            text_scale ? Number(BUTTON_HEIGHT[text_scale]) + 3 : 33.14
          }px !important`};
        min-height: ${({ text_scale }) =>
          `${
            text_scale ? Number(BUTTON_HEIGHT[text_scale]) + 3 : 33.14
          }px !important`};
        font-size: ${({ text_scale }) =>
          parseInt(FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL], 10) -
          1}px !important;
      }
    }
  }
`;
